import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { PropertyGuarantee } from "../../../../global/types";
import GuaranteeDescription from "../../../../components/GuaranteeDescription";
import { getIconByGuaranteeName } from "./getGuaranteeIcon";

interface GuaranteesSectionProps {
  guarantees?: PropertyGuarantee[] | null;
}

function GuaranteesSection({ guarantees }: GuaranteesSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  if (!guarantees || guarantees.length === 0) {
    return null;
  }

  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="mt-6 w-full border-t border-gray-100 px-6 pt-6">
      <h3 className="mb-4 text-lg font-semibold text-gray-800">
        Modalidades de Garantia Aceitas
      </h3>

      <div className="overflow-hidden rounded-xl border border-gray-200">
        {guarantees.map((guarantee, index) => {
          const isOpen = openIndex === index;
          const isLast = index === guarantees.length - 1;

          return (
            <div
              key={guarantee.id}
              className={isLast ? undefined : "border-b border-gray-200"}
            >
              <button
                type="button"
                onClick={() => toggleItem(index)}
                aria-expanded={isOpen}
                className={`flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left transition-colors ${
                  isOpen ? "bg-gray-50" : "bg-white hover:bg-gray-50"
                }`}
              >
                <div className="flex min-w-0 flex-1 items-center gap-3">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#DD6435]/10 text-[#DD6435]">
                    {getIconByGuaranteeName(guarantee.name)}
                  </div>
                  <span className="font-medium text-gray-800">
                    {guarantee.name}
                  </span>
                </div>
                <ChevronDown
                  aria-hidden
                  className={`h-4 w-4 shrink-0 text-gray-400 transition-transform duration-200 ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              <div
                className={`grid transition-[grid-template-rows] duration-200 ${
                  isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                }`}
              >
                <div className="overflow-hidden">
                  {guarantee.description ? (
                    <div className="border-t border-gray-100 bg-white px-4 pb-4 pt-3">
                      <GuaranteeDescription
                        description={guarantee.description}
                        className="pl-12"
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default GuaranteesSection;
